var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BaseSupportModalComponent } from "./base_support.component";
import { FormControl } from "@angular/forms";
var AttachTariffModalComponent = /** @class */ (function (_super) {
    __extends(AttachTariffModalComponent, _super);
    function AttachTariffModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tariffs = [];
        _this.tariffsVariants = [];
        _this.paymentType = 99;
        _this.paymentId = '';
        _this.dateToFilter = false;
        _this.customDateTo = '';
        _this.invoiceNumber = '';
        _this.tariffId = '';
        _this.transactionId = '';
        _this.variantName = '';
        _this.periodType = 1;
        _this.customDaysCount = 1;
        _this.amount = '';
        _this.notFirstPayment = false;
        return _this;
    }
    AttachTariffModalComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.spreader.base.form = this.form;
                        this.form.addControl('customDateTo', new FormControl('', [
                            this.getStandartValidator('customDateTo_format', this.CustomValidators.dateFormat('YYYY-MM-DD'), '"Вариант тарифа" - Неверный(YYYY-MM-DD) формат даты'),
                            this.getStandartValidator('customDateTo_min', this.CustomValidators.dateNotBeforeToday('YYYY-MM-DD'), '"Вариант тарифа" - Дата не может быть меньше текущей'),
                        ]));
                        this.i18nTariffs = this.supportService.i18nTariffs;
                        _a = this;
                        return [4 /*yield*/, this.supportService.getTariffs(this.siteId).toPromise()];
                    case 1:
                        _a.tariffs = _b.sent();
                        this.tariffId = this.tariffs[0]._id;
                        this.updateVariants();
                        return [2 /*return*/];
                }
            });
        });
    };
    AttachTariffModalComponent.prototype.updateVariants = function () {
        var _this = this;
        this.tariffsVariants = this.tariffs.reduce(function (p, c) {
            if (_this.tariffId == c._id) {
                return c.variants;
            }
            return p;
        }, []);
        this.variantName = this.tariffsVariants.length > 0 ? this.tariffsVariants[0].name : '';
    };
    AttachTariffModalComponent.prototype.getInvoiceInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.supportService.getInvoiceInfo(this.siteId, this.invoiceNumber).toPromise()];
                    case 1:
                        data = _a.sent();
                        if (data['invoiceId']) {
                            if (data['totalConverted']) {
                                this.amount = data['totalConverted'];
                            }
                            else {
                                //nf.notify('totalConverted для инвойса #' + $tIdInput.val() + ' не найден');
                                this.amount = '';
                            }
                            this.tariffId = data['tariffId'];
                            this.variantName = data['tariffVariant'];
                        }
                        else {
                            //nf.notify('Инвойс #' + $tIdInput.val() + ' не найден');
                            this.amount = '';
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AttachTariffModalComponent.prototype.ok = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!confirm("\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C \u0442\u0430\u0440\u0438\u0444 \u0441\u0430\u0439\u0442\u0443 " + this.domainUrl + "?")) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.supportService.attachTariff(this.siteId, this.tariffId, this.variantName, this.customDateTo, this.customDaysCount, this.periodType, this.invoiceNumber, this.amount, this.paymentType, this.paymentId, this.notFirstPayment, this.spreader.base.comment).toPromise()];
                    case 1:
                        _a.sent();
                        this.execute();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return AttachTariffModalComponent;
}(BaseSupportModalComponent));
export { AttachTariffModalComponent };
